import type { BlogProps } from "@/types/blog/blog.type";
import type { Locale } from "@/locales";

/**
 * Pick the locale-appropriate text fields off a blog document. Bangla
 * fields are optional — if absent (or empty), fall back to the English
 * value so old documents keep rendering unchanged.
 *
 * Usage:
 *
 *   const { title, shortDescription, content } = pickBlogLocale(blog, locale);
 */
export const pickBlogLocale = (
  b: BlogProps,
  locale: Locale
): {
  title: string;
  shortDescription: string;
  content?: string;
} => ({
  title: locale === "bn" && b.titleBn ? b.titleBn : b.title,
  shortDescription:
    locale === "bn" && b.shortDescriptionBn
      ? b.shortDescriptionBn
      : b.shortDescription,
  content: locale === "bn" && b.contentBn ? b.contentBn : b.content,
});
